import React from 'react';
import { cn } from '../../lib/utils';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost' | 'danger' | 'success' | 'warning';
  size?: 'sm' | 'md' | 'lg' | 'icon';
  isLoading?: boolean;
}
export function Button({
  className,
  variant = 'primary',
  size = 'md',
  isLoading,
  children,
  disabled,
  ...props
}: ButtonProps) {
  const variants = {
    primary: 'bg-accent-500 text-white hover:bg-accent-400 shadow-sm shadow-accent-900/10',
    secondary: 'border border-brand-200 bg-brand-50 text-brand-700 hover:bg-brand-100',
    outline: 'border border-brand-200 bg-white text-brand-700 hover:border-accent-500 hover:bg-accent-50',
    ghost: 'text-brand-700 hover:bg-brand-50',
    danger: 'bg-rose-600 text-white hover:bg-rose-700 shadow-sm',
    success: 'bg-emerald-600 text-white hover:bg-emerald-700 shadow-sm',
    warning: 'bg-amber-500 text-brand-900 hover:bg-amber-400 shadow-sm'
  };
  const sizes = {
    sm: 'h-8 px-3 text-xs',
    md: 'h-10 px-4 text-sm',
    lg: 'h-12 px-7 text-[15px]',
    icon: 'h-10 w-10 p-2 flex items-center justify-center'
  };
  return <button className={cn('inline-flex items-center justify-center rounded-xl font-semibold tracking-[-0.01em] transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent-500 focus-visible:ring-offset-2 focus-visible:ring-offset-brand-50 disabled:pointer-events-none disabled:opacity-50', variants[variant], sizes[size], className)} disabled={disabled || isLoading} {...props} data-id="element-266" data-mp="tku46gnafg03">
      {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" data-id="element-267" data-mp="17f3khflb4whz" />}
      {children}
    </button>;
}